import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import Reveal from './Reveal'

const CtaSection = () => {
  const { t } = useTranslation()

  return (
    <Reveal className='flex flex-col items-center gap-6 rounded-xl bg-primary/5 px-8 py-16 text-center'>
      <div className='flex flex-col items-center gap-3'>
        <h2 className='text-3xl font-medium mb-0'>
          {t('homepage.cta-heading')}
        </h2>
        <p className='max-w-xl text-muted-foreground'>
          {t('homepage.cta-subheading')}
        </p>
      </div>
      <Link
        to='/onboarding'
        className={cn(buttonVariants(), 'gap-2 px-8 py-7 text-xl')}
      >
        {t('homepage.get-started-button')}
        <ArrowRight className='h-5 w-5' />
      </Link>
    </Reveal>
  )
}

export default CtaSection
